__turbopack_context__.v({
  "accordionTitle": "styles-module__a2ffoW__accordionTitle",
  "container": "styles-module__a2ffoW__container",
  "section": "styles-module__a2ffoW__section",
});
